import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isFunction from 'lodash/isFunction';
import noop from 'lodash/noop';
import isNil from 'lodash/isNil';
import clamp from 'lodash/clamp';

import theme from './VSlider.scss';

const propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  oldValue: PropTypes.number,
  setOldValue: PropTypes.func.isRequired,
  viewDefiner: PropTypes.func,
};

const defaultProps = {
  className: '',
  oldValue: null,
  viewDefiner: noop,
};

class VSlider extends PureComponent {

  constructor(props) {
    super(props);

    this.dragging = false;
    this.timer = undefined;

    this.state = {
      updated: false,
      value: clamp(props.value, 0, 100),
    };
  }

  componentDidMount() {
    document.getElementsByTagName('body')[0].addEventListener(
      'mousemove',
      this.onDrag,
    );
  }

  componentWillReceiveProps({ value, oldValue }) {
    if (!isNil(oldValue)) {
      this.oldValue = oldValue;
    }

    if (this.props.value !== value) {
      this.setState({
        updated: true,
        value,
      });
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => this.setState({ updated: false }), 3000);
    }
  }

  componentWillUnmount() {
    document.getElementsByTagName('body')[0].removeEventListener(
      'mousemove',
      this.onDrag,
    );
  }

  onDrag = (event) => {
    if (this.dragging) {
      this.setNewValue(event);
    }
  };

  onChange = (value) => {
    const newValueSafe = clamp(value, 0, 100);

    if (
      newValueSafe !== 0 && 
      (
        !isNil(this.oldValue) || 
        !isNil(this.props.oldValue)
      )
    ) {
      this.oldValue = undefined;
      this.props.setOldValue(null);
    }

    this.props.onChange(newValueSafe);

    this.setState({
      value: newValueSafe,
      updated: true,
    });
  };

  setNewValue = ({ pageY }) => {
    const { bottom, height } = this.indicatorRef.getBoundingClientRect();

    const newValue = Math.round(((bottom - pageY) / height) * 100);
    this.onChange(newValue);
  };

  startDragging = () => {
    this.dragging = true;
  };

  stopDragging = () => {
    this.dragging = false;
  };

  mute = () => {
    if (isNil(this.oldValue) && this.state.value === 0) {
      this.oldValue = 50;
    }

    if (this.oldValue) {
      const val = this.oldValue;
      this.oldValue = undefined;
      this.onChange(val);
      this.props.setOldValue(null);
    } else {
      this.oldValue = this.state.value;
      this.onChange(0);
      this.props.setOldValue(this.state.value);
    }
  };

  render() {
    const {
      className,
      viewDefiner,
    } = this.props;
    // ToDo: need to count value in percents have min max value and current value
    const value = this.state.value;
    const valueInPercents = `${ value }%`;

    const {
      classNameDragPlace,
      classNameValueContainer,
      label,
      icon,
      classNameIcon,
    } = isFunction(viewDefiner) ? viewDefiner(value) : {};

    return (
      <div
        className={ classnames(theme.root, className) }
        onMouseUp={ this.stopDragging }
        onMouseLeave={ this.stopDragging }
        onMouseOver={ this.onDrag }
      >
        <div
          className={ theme.indicatorContainer }
          ref={ (ref) => this.indicatorRef = ref }
          onClick={ this.setNewValue }
        >
          <div
            className={ theme.notActiveLine }
          />
          <div
            className={ theme.activeLine }
            style={ {
              height: valueInPercents,
            } }
          />
          <div
            className={ classnames(theme.dragPlace, classNameDragPlace) }
            onMouseDown={ this.startDragging }
            style={ {
              bottom: valueInPercents,
            } }
          />
          <div
            className={ classnames(theme.valueContainer, classNameValueContainer) }
            style={ {
              bottom: valueInPercents,
              opacity: this.state.updated ? 1 : 0,
            } }
          >
            { label }
          </div>
        </div>
        <div
          className={ classnames(theme.iconContainer, classNameIcon) }
          onClick={ this.mute }
        >
          { icon }
        </div>
      </div>
    );
  }
}

VSlider.propTypes = propTypes;
VSlider.defaultProps = defaultProps;

export default VSlider;
